'use client';

import ProtectedRoute from '../../components/ProtectedRoute';
import Header from '../../components/Header';
import BottomNav from '../../components/BottomNav';
import { usePathname } from 'next/navigation';

export default function LoggedInLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const isBackNineRoute = pathname.startsWith('/back-nine');
  const isLandingPageRoute = pathname.startsWith('/landing-page');
  const isHealthQuizRoute = pathname.startsWith('/health-quiz');
  const isQrHuntRoute = pathname.startsWith('/qr-hunt');

  return (
    <ProtectedRoute redirectTo="/signin">
      <div
        style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}
      >
        <Header />
        <main
          style={{
            flex: 1,
            paddingBottom: isBackNineRoute || isHealthQuizRoute ? '0' : '100px',
          }}
        >
          {children}
        </main>
        {!isBackNineRoute &&
          !isLandingPageRoute &&
          !isHealthQuizRoute &&
          !isQrHuntRoute && <BottomNav />}
      </div>
    </ProtectedRoute>
  );
}
